import { render } from "./UpgradeWindow.vue?vue&type=template&id=40add080&scoped=true"
import script from "./UpgradeWindow.vue?vue&type=script&lang=js"
export * from "./UpgradeWindow.vue?vue&type=script&lang=js"

import "./UpgradeWindow.vue?vue&type=style&index=0&id=40add080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40add080"]])

export default __exports__